import React from 'react';
import { Input } from '../../ui';
import { Plus, Trash2 } from 'lucide-react';

interface WaitChoiceConfigProps {
  config: any;
  onChange: (key: string, value: any) => void;
}

export const WaitChoiceConfig: React.FC<WaitChoiceConfigProps> = ({ config, onChange }) => {
  const groupingEnabled = config.messageGroupingEnabled === true;

  return (
    <div className="space-y-4">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-xs text-blue-700 leading-relaxed">
        <strong>Como funciona:</strong> Aguarda o usuário escolher uma das opções válidas definidas abaixo. A comparação ignora maiúsculas/minúsculas. Se a resposta não corresponder a nenhuma opção, pede que o usuário tente novamente.
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-2">
          Opções Válidas
        </label>
        <div className="space-y-2">
          {(config.validChoices || []).map((choice: string, index: number) => (
            <div key={index} className="flex gap-2">
              <Input
                value={choice}
                onChange={(e) => {
                  const newChoices = [...(config.validChoices || [])];
                  newChoices[index] = e.target.value;
                  onChange('validChoices', newChoices);
                }}
                placeholder={`Opção ${index + 1}`}
              />
              <button
                onClick={() => {
                  const newChoices = (config.validChoices || []).filter((_: any, i: number) => i !== index);
                  onChange('validChoices', newChoices);
                }}
                className="p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
          <button
            onClick={() => {
              const newChoices = [...(config.validChoices || []), ''];
              onChange('validChoices', newChoices);
            }}
            className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-700 font-medium px-2 py-1 hover:bg-blue-50 rounded"
          >
            <Plus className="w-4 h-4" />
            Adicionar Opção
          </button>
        </div>
        <p className="text-xs text-slate-500 mt-2">
          Cada opção criará uma saída no nó para você conectar.
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">
          Mensagem de Erro (Opcional)
        </label>
        <Input
          placeholder="Ex: Opção inválida, tente novamente."
          value={config.errorMessage || ''}
          onChange={(e) => onChange('errorMessage', e.target.value)}
        />
      </div>

      <div className="rounded-lg border border-slate-200 p-3">
        <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
          <input
            type="checkbox"
            checked={groupingEnabled}
            onChange={(e) => onChange('messageGroupingEnabled', e.target.checked)}
          />
          Agrupar mensagens neste bloco
        </label>
        <p className="mt-1 text-xs text-slate-500">
          Quando ativo, o bot aguarda e junta mensagens antes de validar a escolha.
        </p>

        <div className="mt-2 flex items-center gap-2">
          <span className="text-xs text-slate-600">Janela</span>
          <input
            type="number"
            min={1}
            max={120}
            value={Number.isFinite(Number(config.messageGroupingWindowSeconds)) ? Number(config.messageGroupingWindowSeconds) : 5}
            onChange={(e) => onChange('messageGroupingWindowSeconds', Math.max(1, Math.min(120, Number(e.target.value) || 5)))}
            disabled={!groupingEnabled}
            className="w-24 rounded-md border border-slate-300 px-2 py-1 text-sm disabled:opacity-50"
          />
          <span className="text-xs text-slate-600">segundos</span>
        </div>
      </div>
    </div>
  );
};
